export class TenantPlatformLanguage {
  // Default colors match theme.scss variables
  public static readonly DEFAULT_TEAM_LABEL = 'Team';
  public static readonly DEFAULT_TEAM_PUBLIC_NAME_LABEL = 'Team Public Name';
  public static readonly DEFAULT = new TenantPlatformLanguage(
    TenantPlatformLanguage.DEFAULT_TEAM_LABEL,
    TenantPlatformLanguage.DEFAULT_TEAM_PUBLIC_NAME_LABEL
  );
  constructor(
    public teamLabel: string,
    public teamPublicNameLabel: string
  ) {}

  static parse(obj: Partial<TenantPlatformLanguage>): TenantPlatformLanguage {
    return obj
      ? new TenantPlatformLanguage(
          obj.teamLabel || TenantPlatformLanguage.DEFAULT_TEAM_LABEL,
          obj.teamPublicNameLabel || TenantPlatformLanguage.DEFAULT_TEAM_PUBLIC_NAME_LABEL
        )
      : TenantPlatformLanguage.DEFAULT;
  }
}
